/**
 * App store URLs — single source of truth.
 *
 * Update `IOS_APP_URL` after the App Store listing is live by pasting
 * the direct App Store URL (looks like https://apps.apple.com/app/idXXXXXXXXXX).
 */

// ✅ Google Play — direct link to the app page
export const ANDROID_APP_URL =
  "https://play.google.com/store/apps/details?id=com.khanaqin.app";

// 🍎 iOS App Store — DIRECT link to the app page (fastest single-tap install).
// App ID: 6789325328 · Region: Iraq (iq)
export const IOS_APP_URL =
  "https://apps.apple.com/iq/app/hood-%D9%87%D9%88%D8%AF/id6789325328";

// iOS App Store ID (useful for smart banners / deep links)
export const IOS_APP_ID = "6789325328";

// 🌐 Smart universal link — auto-detects the visitor's OS and redirects.
// Recipients can be sent JUST this one link and it "just works" on every phone.
export const UNIVERSAL_DOWNLOAD_URL = "https://khanaqinapp.com/download";

// 📦 Play Store deep-link scheme (opens the Play Store app directly if installed)
export const ANDROID_MARKET_URL = "market://details?id=com.khanaqin.app";

// Package + bundle IDs (useful for deep links / analytics)
export const ANDROID_PACKAGE_ID = "com.khanaqin.app";
export const IOS_BUNDLE_ID = "com.khanaqin.app";
